import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class ProcessingPurposeApi extends BaseApi {
    constructor(client) {
        super(client, '/processing-purpose');
    }

    async getDropdown() {
        try {
            const response = await this.client.get(`${this.basePath}/dropdown/params`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
